$(document).ready(function() {
  
  /*setTimeout(function(){    
    $("#popupNewsletter .fancybox-close-small").click(function(){       
      var t = 0;
      var c = document.querySelector("canvas");     
      var $ = c.getContext('2d');
      c.width = 0;
      c.height = 0;
      $.fillStyle = 'hsla(0,0%,0%,1)';

      function draw() {
        c.width = window.innerWidth;
        c.height = window.innerHeight;
        window.addEventListener('resize', function() {
          c.width = window.innerWidth;
          c.height = window.innerHeight;
        }, false);
        $.globalCompositeOperation = 'source-over';
        $.fillStyle = 'hsla(0,0%,0%,.1)';
        $.fillRect(0, 0, c.width, c.height);
        var foo, i, j, r;
        foo = Math.sin(t) * 2 * Math.PI;
        for (i=0; i<400; ++i) {
          r = 400 * Math.sin(i * foo);
          $.globalCompositeOperation = '';
          $.fillStyle = 'hsla(' + i + 12 + ',100%, 60%,1)';
          $.beginPath();
          $.arc(Math.sin(i) * r + (c.width / 2), 
                Math.cos(i) * r + (c.height / 2), 
                1.5, 0, Math.PI * 2);
          $.fill();

        }
        t += 0.000005;
        return t %= 2 * Math.PI;

      };

      function run() {         
        window.requestAnimationFrame(run);
        draw();
      }   
      run();
       
      var audio = new Audio("https://cdn.shopify.com/s/files/1/0565/9813/4965/files/public-crowd.mp3");      
      audio.play();       
      
       window.setTimeout(function(){
        c.style.display = "none";
       }, 7000);
      
    });     
  }, 10500); */
        
  
  /*setTimeout(function(){
   $(".club-btn").fadeIn(800);  
  }, 5000);
  
  $(".club-btn span").click(function(){
    $(".club-btn").fadeOut(800);
  });*/ 
  
  
  if (window.location.search.indexOf('customer_posted=true') > -1) {
    $(".scuscribe-success-msg").addClass('success-msg-show');
    setTimeout(function() {
       $(".scuscribe-success-msg").removeClass('success-msg-show');
    },10000);    
  } 
 

  /****** Change Theme mode *****/
  $(".switch-color").on("click", function(){
    $("body").toggleClass("white-mode");    
  });

  var switchColor = localStorage.getItem('switchColor');
  checkSwitch();
  function checkSwitch(){
    if(switchColor == "switchOn"){
      $('body').addClass("dark-mode"); 
      $(".check-mode").prop("checked", true);
    } else{
      $(".check-mode").prop("checked", false);
      $('body').removeClass("dark-mode");
    } 
  }
  $('.check-mode').on("change", function(){
    if($(this).is(":checked")){     
      setTimeout(function(){        
        localStorage.setItem('switchColor', "switchOn");  
        $('body').addClass("dark-mode"); 
        $(".check-mode").prop("checked", true);
      }, 500);
    }else{
      localStorage.removeItem('switchColor');
      $(".check-mode").prop("checked", false);
      $('body').removeClass("dark-mode");
    }
  }); 
  
  
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].relList.add('noreferrer', 'noopener');
    }
  }
  /****** End Change Theme mode *****/

  
  /*function handleMarquee() {
    const marquee = document.querySelectorAll('.js-custom-text-carousel');
    let speed = 0.5;
    let lastScrollPos = 0;
    let timer;

    marquee.forEach(function (el) {
      // stop animation on mouseenter
      mouseEntered = false;
      document.querySelector('.custom-text-inner').addEventListener('mouseenter', function () {
        mouseEntered = true;
      })
      document.querySelector('.custom-text-inner').addEventListener('mouseleave', function () {
        mouseEntered = false
      })

      const container = el.querySelector('.custom-text-inner');
      const content = el.querySelector('.custom-text-inner > *');
      //Get total width
      const elWidth = content.offsetWidth;

      //Duplicate content
      let clone = content.cloneNode(true);
      container.appendChild(clone);

      let progress = 1;
      function loop() {
        if (mouseEntered === false) { progress = progress - speed; }
        if (progress <= elWidth * -1) { progress = 0; }
        container.style.transform = 'translateX(' + progress + 'px)';
        window.requestAnimationFrame(loop);
      }
      loop();
    });

    function handleSpeedClear() {
      speed = 1;
    }
  };
  handleMarquee(); 
  
  
  function handleMarqueeClub() {
    const marquee = document.querySelectorAll('.carousel-club');
    let speed = 0.1;
    let lastScrollPos = 0;
    let timer;
    marquee.forEach(function (el) {
      // stop animation on mouseenter
      mouseEntered1 = false;
      document.querySelector('.carousel-club-inner').addEventListener('mouseenter', function () {mouseEntered1 = true;})
      document.querySelector('.carousel-club-inner').addEventListener('mouseleave', function () {mouseEntered1 = false})
      const container = el.querySelector('.carousel-club-inner');
      const content = el.querySelector('.carousel-club-inner > *');
      //Get total width
      const elWidth = content.offsetWidth;
      //Duplicate content
      let clone = content.cloneNode(true);
      container.appendChild(clone);
      let progress = 1;
      function loop() {
        if (mouseEntered1 === false) { progress = progress - speed; }
        if (progress <= elWidth * -1) { progress = 0; }
        container.style.transform = 'translateX(' + progress + 'px)';
        window.requestAnimationFrame(loop);
      }
      loop();
    });
    function handleSpeedClear() {
      speed = 1;
    }
  };
  handleMarqueeClub(); */
  
  
  $('.tab-pane p').each(function() {
	if ( $.trim( $(this).text() ).length == 0 ) {
	  if ( $(this).children().length == 0 ) {
		$(this).text('');
	 	$(this).remove();
      }
	}
  });
  

  var currentDiv = $("#wrap1");
  var nextDiv, count = 1;
  setInterval(function() {
    if (count == 2) {
      currentDiv.stop(true,true).hide(200);
      currentDiv = $("#wrap1");
      currentDiv.stop(true,true).show(800);
      count = 1;
    } else {
      count++;
      currentDiv.stop(true,true).hide(200);
      currentDiv = currentDiv.next();
      currentDiv.stop(true,true).show(800);
    }
  }, 10000); 
  

  
  $('.btn--add-to-cart').on('click',function(e){
   //e.preventDefault();
    $(this).addClass('cart-clicked');
  //  $('.go-to-cart-btn').addClass('show');
    
    window.setTimeout(function(){
      $('.btn--add-to-cart').removeClass('cart-clicked');
     // $("a.minicart-link").trigger("click");
  	}, 3500); 
  });  
  
  /*** Product size sort Low to High ***/
	var divList1 = $("#SingleOptionSelector-0 option");
	divList1.sort(function(a, b){ 
	return $(a).data("value")-$(b).data("value")});
	$("#SingleOptionSelector-0").html(divList1);  
  	/*$('#SingleOptionSelector-0 option[selected="selected"], #ProductSelect-product-template option[selected="selected"]').each(function() {
       $(this).removeAttr('selected');
      }
    ); */
  


  	//$('#SingleOptionSelector-0, #ProductSelect-product-template').prepend($('<option value="" data-value=""></option>'));
     
  
    // mark the first option as selected
    //$("#SingleOptionSelector-0 option:first").attr('selected','selected');

  
  
  var divList = $(".size-list li");
  var checkNum = divList.data("value");
  divList.sort(function(a, b){
  return $(a).data("value")-$(b).data("value")});
  $(".size-list").html(divList);
  $('.size-list li.active').removeClass('active');
  //$(".size-list li:not(.disable-option)").first().addClass("active");
  
  
  if(!$.isNumeric(checkNum)){
    var order = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
    var $wrapper = $('.size-list');
    $wrapper.find('li').sort(function(a, b) {
    var aSize = $(a).data('value'), bSize = $(b).data('value');
    return order.indexOf($(a).data('value')) - order.indexOf($(b).data('value'));
    }).appendTo($wrapper);
    $('.size-list li.active').removeClass('active');
  	//$(".size-list li:not(.disable-option)").first().addClass("active");
  } 
  
  if ($('.prd-block .size-list li:not(.disable-option)').length === 1 ) {
    $('.prd-block .size-list li:not(.disable-option)').addClass("active");
    $('.prd-block_actions .btn.btn--add-to-cart').removeAttr("aria-disabled");	
    setTimeout(function() {
      $('.buy-button-block').removeClass("disabled");
    }, 2000);
  }
  
  $('.prd-block .size-list li').on('click', function() {
   $('.buy-button-block').removeClass("disabled");
   $('#modalQuickView .shopify-payment-button__button').removeAttr("disabled");
  });
  
  $('[data-toggle="tooltip"]').tooltip();
});


$(".top-brands-list").owlCarousel({
  loop:false,
  margin:15,
  dots:false,
  nav:false,
  autoplay:false,                    
  autoplayHoverPause:true,
  autoplaySpeed:1000,
  autoplayTimeout:4000,
  responsive:{
    0:{
      items:3
    },
    600:{
      items:4
    },
    992:{
      items:6,
      autoplay:true,
      loop:true,
    },
    1000:{
      items:7
    }
  }
});

$('.top-prod-button span').on('click', function (e) {
  $(".top-prod-button a").removeClass("show-text");
  $(this).prev("a").addClass("show-text");  
}); 


/*$(window).on('load', function() {
  $('.whats-round').css("display", "flex");
  var whatsCloseCockie = Cookies.get('whatsClose');
  if(whatsCloseCockie == "" || whatsCloseCockie == undefined || whatsCloseCockie == ""){  
    setTimeout(function(){
        $(".whats-chat-block").toggleClass('show');
        var audio = new Audio("https://cdn.shopify.com/s/files/1/0565/9813/4965/files/pristine.mp3?v=1624861600");
        audio.play();    
      }, 10000);
    }
    $('.whats-chat-close').on('click', function (e) {
      var date = new Date();
      Cookies.set('whatsClose', 'yes', { expires:1/48});
      $(".whats-chat-block").removeClass("show");
    });
   $('.whats-round').on('click', function (e) {
    $(".whats-chat-block").toggleClass('show');
    var audio = new Audio("https://cdn.shopify.com/s/files/1/0565/9813/4965/files/pristine.mp3?v=1624861600");
    audio.play();     
  });   
});*/

/*var d = new Date();
var day = d.getDate();
var month = d.getMonth() + 1;
var year = d.getFullYear();
var dates = day+"."+month+"."+year;
document.getElementById("dates").innerHTML = dates;
var hour = d.getHours(); 
var mint = d.getMinutes(); 
var times = hour+":"+mint;
document.getElementById("times").innerHTML = times;
var days = ["ראשון","שני","שלישי"," רביעי","חמישי","שישי","שבת"];
document.getElementById("days").innerHTML = days[d.getDay()]; */

/****
$(".shopify-product-form").on('submit',function(e){
  $("a.minicart-link").trigger("click");
});****/


$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 130) {
    $(".hdr-content").addClass("fixed-header");
  } else {
    $(".hdr-content").removeClass("fixed-header");
  }
});

$("#filterRow li[data-value='women'] a").text("נשים");
$("#filterRow li[data-value='men'] a").text("גברים");
$("#filterRow li[data-value='shoes'] a").text("נעליים");
$("#filterRow li[data-value='childrens-clothing-accessories'] a").text("תיקים ואביזרים");
$("#filterRow li[data-value='mens-clothing-accessories'] a").text("ביגוד ואקססוריז גברים");
$("#filterRow li[data-value='womens-clothing-accessories'] a").text("ביגוד ואקססוריז נשים");

/******Shopify Cart Note*******/
Shopify.updateCartNote = function(t, r) {
  var o = {
    type: "POST",
    url: window.router + "/cart/update.js",
    data: "note=" + attributeToString(t),
    dataType: "json",
    success: function(t) {
      "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
    },
    error: function(t, r) {
      Shopify.onError(t, r)
    }
  };
  jQuery.ajax(o)
}
/******End Shopify Cart Note*******/

function instantBuy(){
   var $ = jQuery;
   var formParams = $('form.cart').serialize();
     $.ajax({
      url: "/cart/add",
      type: "post",
      data: formParams,
      success: function(){ 
       window.location.href = "/checkouts";
      },
      error: function(){
      }
     })
 }
$(document).ready(function(){  
if ($(".size-list.js-size-list li").hasClass("active")) {
  $(".buynow-btn").prop("disabled", false);
  $(".buynow-btn").css("opacity","1");
  $(".buynow-btn").css("cursor","pointer");
}

$(".size-list.js-size-list li a").on('click', function(e){
  $(".buynow-btn").prop("disabled", false);
  $(".buynow-btn").css("opacity","1");
  $(".buynow-btn").css("cursor","pointer");
});
});


// $(document).ready(function(){ 
// if ($(".size-list.js-size-list li").hasClass("active")) {
//     $(".shopify-payment-button__button").css("cursor","pointer");
//     $(".shopify-payment-button__button").css("pointer-events","unset");
//     $(".shopify-payment-button__button").css("opacity","1");
// }
// $(".size-list.js-size-list li a").on('click', function(e){
//   $(".shopify-payment-button__button").css("cursor","pointer");
//   $(".shopify-payment-button__button").css("pointer-events","unset");
//    $(".shopify-payment-button__button").css("opacity","1");
// })

// });


$(".js-topline").owlCarousel({
  margin:0,
  dots:false,
  nav:false,
  autoplay:true,
  autoplayTimeout:5000,
  loop:true,           
  rtl: true,
  autoplayHoverPause:false,
  autoplaySpeed:1000,
  items:1
});

 

